import React, { useState, useEffect, useRef } from "react";
import { useSelector } from "react-redux";
import * as Yup from "yup";
import { submitGcaEnclosureFiles, submitGcaEnclouser } from "../../auth/services/privateapicalling";

import { toast,ToastContainer } from "react-toastify";


interface EnclosureProps {
  onNext: (data: any) => void;
  onPrev: () => void;
  isEnclouserFilled: boolean;
  existData:any;
  applicationId:string | null;
  fetchApplicationExistenceCheck: () => Promise<void>;
}

const Enclosures: React.FC<EnclosureProps> = ({ onNext, onPrev ,fetchApplicationExistenceCheck,applicationId, isEnclouserFilled,existData}) => {
//.log('existData enc',existData) // Moved or removed to avoid error

  const [files, setFiles] = useState<{ [key: string]: File | null }>({});
  // const [uploading, setUploading] = useState<{ [key: string]: boolean }>({});
  // const [uploadStatus, setUploadStatus] = useState<{ [key: string]: boolean }>({});
  const [uploading, setUploading] = useState(false);
  const [loading, setLoading] = useState(false);

  const language = useSelector((state: any) => state.auth.language);
  const formLanguage = useSelector((state: any) => state.auth.formLanguage)
  
  const token = useSelector((state: any) => state.auth.token);
    const userdetails = useSelector((state: any) => state.auth.userDetails);
    const applicationIdRedux = useSelector((state:any)=>state.auth.applicationId);
    const appId = userdetails.applicationId ? userdetails.applicationId : applicationIdRedux;
    const [isAllFieldsUploaded, setIsAllFieldsUploaded] = useState<boolean>(false);
    const [uploadedFiles, setUploadedFiles] = useState({});
    const [errors, setErrors] = useState({});
    const [selectedLang, setSelectedLang] = useState<string>("");
    

    const entityType = existData?.entityType;

  const  allFields = [
    {type:"solvencyCertificate",allowRole:["Ind","Firm","Company","CoSciety","Fpo","govEnt","Ngo","partnerFirm","Llp","Trust","Jv"],label:"Solvency Certificate"},
    {type:"bankGuarntee",allowRole:["Ind","Firm","Company","CoSciety","Fpo","govEnt","Ngo","partnerFirm","Llp","Trust","Jv"],label:"Bank Guarantee"},
    {type:"bankBalanceCertificate",allowRole:["Ind","Firm","Company","CoSciety","Fpo","govEnt","Ngo","partnerFirm","Llp","Trust","Jv"],label:"Bank Balance Certificate"},
    {type:"itReturns_1",allowRole:["Ind","Firm","Company","CoSciety","Fpo","govEnt","Ngo","partnerFirm","Llp","Trust","Jv"],label:"IT Returns 1"},
    {type:"itReturns_2",allowRole:["Ind","Firm","Company","CoSciety","Fpo","govEnt","Ngo","partnerFirm","Llp","Trust","Jv"],label:"IT Returns 2"},
    {type:"itReturns_3",allowRole:["Ind","Firm","Company","CoSciety","Fpo","govEnt","Ngo","partnerFirm","Llp","Trust","Jv"],label:"IT Returns 3"},
    {type:"gstCertificateDocs",allowRole:["Ind","Firm","Company","CoSciety","Fpo","govEnt","Ngo","partnerFirm","Llp","Trust","Jv"],label:"GST Certificate"},
    {type:"panCard",allowRole:["Ind","Firm","Company","CoSciety","Fpo","govEnt","Ngo","partnerFirm","Llp","Trust","Jv"],label:"Pan Card "},
    {type:"electionCard",allowRole:["Ind","Firm","Company","CoSciety","Fpo","govEnt","Ngo","partnerFirm","Llp","Trust","Jv"],label:"Election Card"},
    {type:"chalanPayementLiceneseFeeDoc",allowRole:["Ind","Firm","Company","CoSciety","Fpo","govEnt","Ngo","partnerFirm","Llp","Trust","Jv"],label:"Challan Payment License Fee"},                                                                                                                                                                                                                                                                                                                
    {type:"proofOfBusinessPalace",allowRole:["Ind","Firm","Company","CoSciety","Fpo","govEnt","Ngo","partnerFirm","Llp","Trust","Jv"],label:"Proof of Business Place"},
    {type:"partnerShipDeed",allowRole:["partnerFirm"],label:"Partnership Deed"},
    {type:"companyArticleAssociation",allowRole:["Firm","Company","CoSciety","Llp"],label:"Company Article Association"},
    {type:"coOpSocietyByLaws",allowRole:["CoSciety"],label:"Co-operative Society Bye Laws"},
    {type:"affidavit",allowRole:["Ind","Firm","Company","CoSciety","Fpo","govEnt","Ngo","partnerFirm","Llp","Trust","Jv"],label:"Affidavit"},
    // {type:"enclousreDeclaration",allowRole:["Ind","Firm","Company","CoSciety","Fpo","govEnt","Ngo","partnerFirm","Llp","Trust","Jv"],label:"Enclosure Declaration"},
    {type:"declarations",allowRole:["Ind","Firm","Company","CoSciety","Fpo","govEnt","Ngo","partnerFirm","Llp","Trust","Jv"],label:"Declarations"},
    {type:"agentSignature",allowRole:["Ind","Firm","Company","CoSciety","Fpo","govEnt","Ngo","partnerFirm","Llp","Trust","Jv"],label:"Agent Signature"},
     
  ];

  const fields =  allFields.filter(data=>data.allowRole.includes(existData?.entityType))

  const today = new Date();
const currentYear = today.getFullYear();
const july31 = new Date(currentYear, 6, 31); // July is month 6 (0-indexed)
const endYear = today <= july31 ? currentYear - 1 : currentYear;

const fiscalYears = [];
for (let i = 0; i < 3; i++) {
  const fyEnd = endYear - i;
  const fyStart = fyEnd - 1;
  fiscalYears.push(`FY ${fyStart}-${fyEnd}`);
}

const updatedFields = fields.map((field) => {
  if (field.type === "itReturns_1") {
    return { ...field, label: `IT Returns (${fiscalYears[0]})` };
  } else if (field.type === "itReturns_2") {
    return { ...field, label: `IT Returns (${fiscalYears[1]})` };
  } else if (field.type === "itReturns_3") {
    return { ...field, label: `IT Returns (${fiscalYears[2]})` };
  }
  return field;
});

 

  const validationSchemaforsubmit = Yup.object().shape({
    uploadedFiles: Yup.object().shape(
      fields.reduce((acc, field) => {
        // Skip validation for gstCertificateDocs (make it optional)
        if (field.type === "gstCertificateDocs") {
          acc[field.type] = Yup.mixed().notRequired();
        } else {
          acc[field.type] = Yup.mixed()
            .test("required", `${field.label} is required`, (value) => value && value instanceof File)
            .required(`${field.label} is required`);
        }
        // .log('acc',acc)
        return acc;
      }, {})

    ),
   
  });


  
  

  const validate = async () => {
    try {
      //.log('files', files); // Log the actual files state
      const validFiles = Object.keys(files).reduce((acc, key) => {
        if (files[key]) {
          acc[key] = files[key];
        }
        return acc;
      }, {});

      //.log('validFiles', validFiles); // Log only valid files
      await validationSchemaforsubmit.validate({ uploadedFiles: validFiles }, { abortEarly: false });
      //.log("All files are valid. Submitting...", validFiles);
      setErrors({});
      return true; // Indicate successful validation
    } catch (err) {
      const validationErrors: { [key: string]: string } = {};
      if (err instanceof Yup.ValidationError) {
        err.inner.forEach((error) => {
          if (error.path) {
            validationErrors[error.path.split(".")[1]] = error.message;
          }
        });
      }
      setErrors(validationErrors);
      //.error("Validation errors:", validationErrors);
      return false; // Indicate validation failure
    }
  };

  const handleFileChange = (e: React.ChangeEvent<HTMLInputElement>, fieldName: string) => {
    const file = e.target.files?.[0] || null;
   
    setFiles((prev) => ({ ...prev, [fieldName]: file }));
    
    setErrors((prev: any) => {
    const next = { ...prev };
    delete next[fieldName];
    return next;
  });


      const existingDoc = existData && existData.docs?.find((doc: any) => doc.documentName === fieldName);
                         
                          handleUpload(fieldName,file, existingDoc?.id)
  };

    const toastCooldown = useRef(false);
  
    const showErrorToast = (message: string) => {
      if (toastCooldown.current) return; // Skip if still in cooldown
    
      toast.error(message);
      toastCooldown.current = true;
    
      // Reset cooldown after 3 seconds
      setTimeout(() => {
        toastCooldown.current = false;
      }, 3000);
    };


  const handleUpload = async (fieldName: string, fileData: any, docId?: string | null) => {
    if (!fileData) return;
  

  
    const formData = new FormData();
    formData.append("file", fileData as Blob);
    formData.append("documentName", fieldName);
    formData.append("applicationId", applicationId);
  
    // setUploading((prev) => ({ ...prev, [fieldName]: true }));
  

    try {
      setUploading(true);
      const res = await submitGcaEnclosureFiles(formData, token, docId);
      fetchApplicationExistenceCheck()
      setUploadedFiles((prev) => ({ ...prev, [fieldName]: true }));
   
      if(res.success==true)
        {
          toast.success(res?.message, {position: "top-right", autoClose: 3000,});
        }
        else{
          toast.error(res?.message, {position: "top-right", autoClose: 3000,});
        }
    } catch (error) {
      // alert("File upload failed");
      toast.error("File upload failed", {position: "top-right", autoClose: 3000,});
    } finally {
      // setUploading((prev) => ({ ...prev, [fieldName]: false }));
      setUploading(false);
    }
  };

  const handleDownload = (fileNames: string[]) => {
    fileNames.forEach((fileName) => {
      const fileUrl = `/${fileName}`; // Ensure correct file path
  
      const link = document.createElement("a");
      link.href = fileUrl;
      link.setAttribute("download", fileName);
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    });
  };

  const areAllFilesUploaded = () => {
    return updatedFields.every((field) => {
      // Skip GST Certificate check as it's optional
      if (field.type === "gstCertificateDocs") {
        return true;
      }
      return uploadedFiles[field.type];
    });
  };

  const handleSubmit = async () => {
  
    // const isValid = validateAndSubmit()
    // //.log('is valid',isValid)
    const isValid = await validate()
    //.log('is valid',isValid)
    if (!isValid) {
      //.log("Validation failed. Fix errors before submitting.");
      return;
    }

    if (!areAllFilesUploaded()) {
      showErrorToast("Please upload all required documents before submitting.");
      return;
    }

    // if ( isAllFieldsUploaded) {
      const body = {
        applicationId:applicationId,
        isEnclouserFilled:true
      }
      setLoading(true);
      const submitEnclouserStatus = await submitGcaEnclouser(body , token)
      // //.log('submitEnclouserStatus',submitEnclouserStatus)
      setLoading(false);
      onNext(files);
    // }
  };

  useEffect(() => {
    if (existData?.docs?.length && updatedFields?.length) {
      const uploadedMap: Record<string, boolean> = {};
  
      updatedFields.forEach((field) => {
        const isUploaded = existData.docs.some(
          (doc) => doc.documentName === field.type
        );
        if (isUploaded) {
          uploadedMap[field.type] = true;
        }
      });
  
      setUploadedFiles(uploadedMap);
    }
  }, []);


 //.log("existData.entityType",existData.entityType)
  return (
    <div className="">
      <div className="">
        <div className="row">
          <div className="col-md-12">
            <div className="card">
              <div className="card-header">
                <h5 className="card-title">{language.enclosures_heading}</h5>
                <p className="text-danger mb-1">{language.file_type}</p>
              </div>
              <div className="card-body">
                <form>
                  <div className="row">
                    {updatedFields.map((field, index) => (
                      
                      <>
                      {/* field.allowRole.includes(existData.entityType ) &&  */}
                   {  
                      <div key={field.type} className="col-md-6 mb-3">
                       
                          {/* <span className="text-danger">*</span> */}
                          <label className="col-form-label">
                              {/* {index + 1}. {formLanguage[field.type]} ({language[field.type]}) */}
                              {index + 1}. {
                                  ["itReturns_1", "itReturns_2", "itReturns_3"].includes(field.type)
                                    ? `${formLanguage[field.type]} (${field.label})`
                                    : `${formLanguage[field.type]} (${language[field.type]})`
                                }
                              <span className="text-danger">*</span>
                              
                              {field.type === "declarations" && (
                                <div className="d-flex align-items-center">
                                 
                        
 
                                  <button
                                    type="button"
                                    className="btn btn-link text-danger"
                                    onClick={() => {
                                      // if (!selectedLang) {
                                      //   alert("Please select a language"); // Alert if no language is selected
                                      //   return;
                                      // }
                                      handleDownload(
                                         [
                                              "EnclosureDeclarationCommon.pdf",
                                            ]
                                      );
                                    }}
                                  >
                                      <span className="text-danger">Declaration</span><i
                                      className="fa fa-file-pdf"
                                      data-bs-toggle="tooltip"
                                      title="Download Declaration"
                                    />
                                  </button>
                                </div>
                              )}
                            </label>
 
                        <div className="d-flex flex-column w-100">
                          <input
                          className={`form-control` }
                          type="file"
                          accept=".pdf, .jpeg, .jpg"
                          onChange={(e) => handleFileChange(e, field.type)}
                          />
                            {existData && existData.docs?.find((doc: any) => doc.documentName === field.type)?.fileName && (
                            <>
                            <p>{existData.docs.find((doc: any) => doc.documentName === field.type)?.fileName}</p>
                            {files[field.type] === undefined && (() => {
                              setFiles((prev) => ({
                                ...prev,
                                [field.type]: new File([], existData.docs.find((doc: any) => doc.documentName === field.type)?.fileName || ""),
                              }));
                              return null;
                            })()}
                            </>
                            
                            )}
                          
                          
                        </div>
                        {errors[field.type] && (
                          <p className="text-danger">{errors[field.type]}</p>
                        )}
               
                        </div>}
                      </>
                    ))}
                  </div>
                  <div className="d-flex justify-content-start mt-3">
                    <button type="button" className="btn btn-secondary" onClick={onPrev}>
                      {language.previous}
                    </button>
                   </div>
                   <div className="d-flex justify-content-end mt-3">
                    <button type="button" className="btn btn-primary" onClick={handleSubmit}  
                    // disabled={!isAllFieldsUploaded}  
                     >
                      {language.next}
                    </button>
                    {/* <ToastContainer position="top-center" autoClose={3000} /> */}
                    
                  </div>
                  {/* {!isAllFieldsUploaded && <p className="text-danger mt-2">All files must be uploaded before proceeding.</p>} */}
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
            {(uploading || loading) && (
        <div
          className="position-fixed top-0 start-0 w-100 h-100 d-flex justify-content-center align-items-center bg-dark bg-opacity-25"
          style={{ zIndex: 9999 }}
        >
          <div className="d-flex align-items-center px-4 py-3 bg-white rounded shadow">
            <div
              className="spinner-border text-primary me-3"
              role="status"
            />
            <span className="fw-semibold text-dark">
              {uploading ? "Uploading..." : "Submitting..."}
            </span>
          </div>
        </div>
      )}
    </div>
  );
};

export default Enclosures;
